<template lang="html">

    <main class="ofertas-section">
        <nav class="ofertas-selector row-start">
            <button v-if="ofertas.practicas.length != 0" @click="selected = 'practicas'"
                :active="selected == 'practicas'">Ofertas</button>
            <button v-if="programas.length != 0" @click="selected = 'programas'" :active="selected == 'programas'">Programas</button>
        </nav>
        <div class="ofertas-list" v-if="selected == 'empleo' || selected == 'practicas'">
            <article class="oferta row-between ais" v-for="el in ofertas[selected]"
                v-if="ofertas[selected].length != 0">
                <main>
                    <h5 class="empresa">{{el.empresa}}</h5>
                    <h2>{{el.titulo}}</h2>
                </main>
                <aside>
                    <h5 class="fecha">{{el.fechaDestacada}}</h5>
                    <h5 class="provincia">{{el.provincia}}</h5>
                </aside>
                <a target="_blank" :href="$t('portalalumno')+'ofertas-'+selected+'/'+el.urlAcceso"
                    class="enlace-cover"></a>
            </article>
        </div>


        <div class="ofertas-list" v-if="selected == 'programas'">

            <article class="oferta -programa row-between ais" v-for="programa in programas.slice(0,5)">
                <main>
                    <h5 class="empresa">{{programa.financiacion}}</h5>
                    <h2>{{programa.titulo}}</h2>
                    <p title="Nivel de estudios permitidos">   
                        <template v-for="(estudio, pos) in programa.tiposEstudios">
                        {{(pos == 1) ? 'y' : ''}} {{tiposEstudios[estudio]}}
                      </template></p>
                </main>
                <aside>
                    <h5 class="fecha">{{programa.fechaInicio}} {{(!!programa.fechaFin) ? '-' : null}}
                        {{programa.fechaFin}}</h5>
                    <h5 class="duracion" title="Duración">{{programa | duracion}}</h5>

                </aside>
                <router-link :to="$t('enlaces.programas')+'/'+programa.urlAcceso" class="enlace-cover">
                </router-link>
            </article>
        </div>

        <router-link class="link" v-if="!!programas.length != 0 && selected == 'programas'" :to="$t('enlaces.programas')">Ver más</router-link>
        <a class="link" v-if="selected == 'empleo' || selected == 'practicas'" :href="$t('portalalumno')">Ver más</a>
    </main>

</template>

<script lang="js">

    import { mapGetters } from 'vuex';


    export default {
        name: 'ofertas',
        data() {
            return {
                selected: 'programas',
                tiposEstudios : {
                    1 : "Estudios universitarios",
                    2 : 'Formación profesional'
                }
            }
        },
        computed: {
            ...mapGetters({
                ofertas: 'getOfertas',
                programas: 'getProgramas'
            })
        },
        filters: {
            duracion(value) {


                let inicio = (!!value.meses) ? value.meses.split(",")[0] : '';
                let fin = (!!value.meses2) ? value.meses2.split(",")[0] : '';

                let string = inicio;
                string += (!!fin) ? ` ${value.operadorMeses} ${fin}` : '';
                string += (!!fin || inicio != "1") ? ' meses' : ' mes';

                return string;

            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/view-parts/home/ofertas.vue